<script lang="ts">
export default {
  name: 'BreadCrumb'
};
</script>

<script lang="ts" setup>
import { useLanguage } from '#composables/useLanguage';
import { useUserStore } from '#stores/user.store';
import { IconVueFeather } from '@c4-links/vue3-links-components';
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';

const userStore = useUserStore();
const { t } = useLanguage();

const props = defineProps({
  showIcon: { type: Boolean, default: false, required: false },
  separator: { type: String, default: '∙', required: false }
});

const currentRoute = useRoute();

const items = computed(() => {
  return currentRoute.meta?.breadcrumbs ?? [];
});

const classes = computed(() => ({
  mainContainer: 'flex items-center text-sm gap-x-1',
  // TODO: Remove condition on showIcon when all permission management is done
  titleContainer: (index: number) =>
    index === 0 && props.showIcon
      ? 'text-primary flex items-center text-sm gap-x-1'
      : 'flex items-center text-sm gap-x-1',
  separatorWithIcon: props.showIcon ? 'text-persistent-border-main-primary' : ''
}));
</script>

<template>
  <div :class="classes.mainContainer">
    <span v-if="!showIcon">{{ userStore.userCountry && t(`commonLabel.${userStore.userCountry}`) }}</span>

    <template v-for="(item, index) in items" :key="item.title">
      <template v-if="$slots.separator && index > 0">
        <slot name="separator" />
      </template>

      <template v-else-if="index > 0">
        <span :class="classes.separatorWithIcon">{{ separator }}</span>
      </template>

      <RouterLink v-if="item.to" :to="{ name: item.to?.name }">{{ t(item.title) }}</RouterLink>

      <span v-else :class="classes.titleContainer(index)">
        <IconVueFeather v-if="showIcon && item.icon" :type="item.icon" :size="16" />
        {{ t(item.title) }}
      </span>
    </template>
  </div>
</template>
